import { Buttons } from '@platform/shared/ui';
import React from 'react';

const SnackbarActionButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ children }) => (
  <Buttons.Link className="text-primary-300 rounded-full px-4 hover:bg-zinc-700">{children}</Buttons.Link>
);

export default SnackbarActionButton;
